import React from 'react';

const IconSeparator = () => (
    <span className="icon-separator" />
);

export default IconSeparator;
